import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";
import { Table, TableRow, TableHead, TableContainer, Box, Grid, Avatar, Fab, } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import Assets from "../../Components/Common/ImageContainer";
import PaperContainer from "../../Components/Common/PaperContainer";
import TableHeading from "../../Components/Common/CommonTableHeading";
import CommonModal from "../../Components/Common/CommonModel";
import { useAppContext } from "../../Context/context";
import axios, { Image_BASE_URL } from "../../APiSetUp/axios";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import AddBranch from "../../Components/Designation";
import DataNotFound from "../../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { lightTheme } from "../../theme";
import { permissionStatus, Roles, userType } from "../../Utils/enum";
import { Regex } from "../../Utils/regex";
import WidgetLoader from "../../Components/Common/widgetLoader";
import Swal from "sweetalert2";
import CustomPagination from "../../Components/Common/CustomPagination";
import AddDesignation from "../../Components/Designation";
import AddSiteType from "../../Components/SiteType";
import dayjs from "dayjs";
import TextLabel from "../../Components/Common/Fields/TextLabel";
import AddEmployeAttendance from "../../Components/EmployeAttendance";
import AutoCompleteSearch from "../../Components/Common/commonAutoComplete";
import DownloadIcon from '@mui/icons-material/Download';
import { downloadFileFromBlob } from "../../Utils/helper";
import DwonloadEmploye from "../../Components/EmployeAttendance/dwonloadEmploye";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.primary.main,
    fontFamily: "Poppins",
    padding: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: 500,
    padding: "8px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const useStyles = makeStyles()((theme) => {
  return {
    paddedRow: {
      padding: "15px 10px",
    },
    writeBox: {
      borderRadius: "6px",
      padding: "8px",
      backgroundColor: lightTheme.palette.bgLightExtraPrimary.main,
      color: lightTheme.palette.primary.main,
      cursor: "pointer",
    },
    viewBox: {
      borderRadius: "6px",
      padding: "8px",
      color: lightTheme.palette.bgLightSuccess.main,
      backgroundColor: lightTheme.palette.bgLightExtraSuccess.main,
      cursor: "pointer",
    },
    deleteBox: {
      borderRadius: "6px",
      padding: "8px",
      color: lightTheme.palette.bgLightRed.main,
      backgroundColor: lightTheme.palette.bgLightExtraRed.main,
      cursor: "pointer",
    },
  };
});

const EmployeAttendance = () => {
  const { classes } = useStyles();
  const location = useLocation();
  const { pathname } = location;

  const { OnUpdateError, toggleLoader, menuList, user } = useAppContext();

  //States
  const [model, setModel] = useState(false);
  const [isDwonloadExcel, setIsDwonloadExcel] = useState(false);
  const [data, setData] = useState({ employe: "", date: "", status: "", clockInTime: "", clockOutTime: "" });
  const [error, setError] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [employeAttendanceDetails, setEmployeAttendanceDetails] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [permissions, setPermissions] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false)
  const [employeList, setEmployeList] = useState([])
  const [dwonloadFilter, setDwonloadFilter] = useState({
    startDate: null,
    endDate: null
  })
  const [dwonloadFilterError, setDwonloadFilterError] = useState({});

  const [employeId, setEmployeId] = useState('')
  const [dwonloadEmployeId, setDwonloadEmployeId] = useState([])

  const [statusList, setStatusList] = useState([
    { id: 1, name: "Present" },
    { id: 2, name: "Absent" },
    { id: 3, name: "Leave" },
    { id: 4, name: "Holiday" },
  ])

  console.log('data', data)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const _getEmploye = async () => {
    setLoading(true)
    let body = {
      userType: [2]
    };
    await axios.post("/users", body)
      .then((res) => {
        if (res?.data?.data) {
          setEmployeList(res?.data?.data?.response);
          setEmployeId(res?.data?.data?.response?.[0]?.name)
        }
      })
      .catch((err) => {
        OnUpdateError(err.data.message);
      }).finally(() => setLoading(false));
  }

  //Validation
  const handleValidation = () => {
    let formIsValid = true;
    let errors = {};

    if (!data?.employe) {
      formIsValid = false;
      errors["employe"] = "Please select employe.";
    }
    if (!data?.date) {
      formIsValid = false;
      errors["date"] = "Please select attendance Date.";
    }
    if (!data?.status) {
      formIsValid = false;
      errors["status"] = "Please select status.";
    }
    if (!data?.clockInTime) {
      formIsValid = false;
      errors["clockInTime"] = "Please select clockIn Time.";
    }
    if (!data?.clockOutTime) {
      formIsValid = false;
      errors["clockOutTime"] = "Please select clockOut time.";
    }
    setError(errors);
    return formIsValid;
  };

  const handleDwonloadFilterValidation = () => {
    let formIsValid = true;
    let errors = {};

    if (dwonloadFilter?.endDate && !dwonloadFilter?.startDate) {
      formIsValid = false;
      errors["startDate"] = "Please select state date.";
    }

    if (dwonloadFilter?.startDate && !dwonloadFilter?.endDate) {
      formIsValid = false;
      errors["endDate"] = "Please select  end date.";
    }
    setDwonloadFilterError(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const _getEmployeAttendance = () => {
    setLoading(true)
    let body = {
      limit: rowsPerPage,
      page: page,
      search: search || "",
    };
    if (employeId && user?.userType !== Roles?.Employe) {
      body.employeId = employeList?.find(ele => ele.name === employeId)?._id
    }
    axios.post(`/attendance`, body)
      .then((res) => {
        if (res?.data?.data) {
          setEmployeAttendanceDetails(res?.data?.data);
        }
      })
      .catch((err) => {
        OnUpdateError(err.data.message);
      }).finally(() => setLoading(false));
  };

  const handleClear = () => {
    setModel(false);
    setData({});
    setError({});
    setIsEdit(false);
    setIsDwonloadExcel(false)
    setDwonloadEmployeId([])
    setDwonloadFilter({
        startDate: null,
        endDate: null
      }
    )
  };

  const _addUpdateEmployeAttendance = () => {
    if (handleValidation()) {
      toggleLoader();
      let body = {
        "employeId": employeList?.find((e) => e?.name == data?.employe)?._id,
        "clockInTime": new Date(data?.clockInTime),
        "clockOutTime": new Date(data?.clockOutTime),
        "date": new Date(data?.date),
        "status": data?.status,
      };
      if (data?._id) {
        body.id = data?._id;
      }
      axios
        .post(`attendance/${data?._id ? "update" : "create"}`, body)
        .then((res) => {
          if (res?.data?.data) {
            swal("Success", res?.data?.message, "success");
            handleClear();
            _getEmployeAttendance();
          }
          toggleLoader();
        })
        .catch((err) => {
          toggleLoader();
          OnUpdateError(err.data.message);
        });
    }
  };

  const _handleDelete = (deleteId) => {
    Swal.fire({
      title: "<strong>Warning</strong>",
      icon: "error",
      html: "Are you sure you want to Delete Employe Attendance ",
      showCancelButton: true,
      confirmButtonColor: "#0492c2",
      iconColor: "#ff0000",
      confirmButtonText: "Yes",
      cancelButtonColor: "#1A1B2F",
    }).then(async (result) => {
      if (result.isConfirmed) {
        toggleLoader();
        axios
          .delete(`/attendance/delete/${deleteId}`)
          .then((res) => {
            swal("Success", res?.data?.message, "success");
            toggleLoader();
            _getEmployeAttendance();
          })
          .catch((err) => {
            toggleLoader();
            OnUpdateError(err.data.message);
          });
      }
    });
  };

  const _downloadEmployeAttendance = async () => {
    if (handleDwonloadFilterValidation()) {
      const body = {
        employeId: dwonloadEmployeId.map((item) => item._id),
        startDate: dwonloadFilter?.startDate ? dayjs(dwonloadFilter?.startDate).format("YYYY-MM-DD") : null,
        endDate: dwonloadFilter?.endDate ? dayjs(dwonloadFilter?.endDate).format("YYYY-MM-DD") : null
      }
      await axios.post(`attendance/dwonload`, dwonloadEmployeId ? body : {}, { responseType: "blob" })
        .then((res) => {
          if (res?.data) {
            downloadFileFromBlob(res?.data, "attendance.xlsx")
            setDwonloadEmployeId([])
            setDwonloadFilter({
              startDate: null,
              endDate: null
            })
            setIsDwonloadExcel(false)
          }
        })
        .catch((err) => {
          toggleLoader();
          OnUpdateError(err.data.message);
        });
    }
  };

  useEffect(() => {
    _getEmploye()
  }, [model])

  useEffect(() => {
    _getEmployeAttendance();
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    if (user?.userType !== Roles?.Employe) {
      _getEmployeAttendance();
    }
  }, [employeId]);

  useEffect(() => {
    const menu = menuList?.find((e) => e?.path === pathname);
    if (menu) {
      const menuPermissions = menu.permissions;
      setPermissions({
        view: menuPermissions.includes(permissionStatus.view) ? true : false,
        create: menuPermissions.includes(permissionStatus.create) ? true : false,
        update: menuPermissions.includes(permissionStatus.update) ? true : false,
        delete: menuPermissions.includes(permissionStatus.delete) ? true : false,
      });
    }
  }, [menuList, location]);

  return (
    <>
      <PaperContainer elevation={0} square={false}>
        <Grid container>
          <Grid item xs={12}>
            <TableHeading
              title="Employee Attendance List"
              buttonText={permissions?.create ? `Add Employee Attendance` : ""}
              onClick={() => setModel(true)}
              handleSearch={(value) => { setPage(1); setSearch(value); }}
              filter={user?.userType !== Roles?.Employe ? true : false}
              employeId={employeId}
              setEmployeId={setEmployeId}
              employeList={employeList}
              children={
                <>
                  <Fab size="small" color="primary" aria-label="add" onClick={() => setIsDwonloadExcel(true)}>
                    <DownloadIcon fontSize="small" />
                  </Fab>
                </>
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              {!loading ? (
                <Table sx={{ minWidth: 600 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell className={classes.paddedRow}>No.</StyledTableCell>
                      <StyledTableCell className={classes.paddedRow}>Profile</StyledTableCell>
                      <StyledTableCell>Employee</StyledTableCell>
                      <StyledTableCell>Date</StyledTableCell>
                      <StyledTableCell>Time</StyledTableCell>
                      <StyledTableCell>Status</StyledTableCell>
                      {user?.userType !== Roles?.Employe && <StyledTableCell align="center" >Action</StyledTableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {employeAttendanceDetails?.response?.length > 0 ? employeAttendanceDetails?.response?.map((row, index) => {
                      return (
                        <StyledTableRow key={index}>
                          <StyledTableCell className={classes.paddedRow}>{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                          <StyledTableCell><Avatar src={Image_BASE_URL + row?.employeDetails?.avtar} /></StyledTableCell>
                          <StyledTableCell component="th" scope="row">{row.employeDetails?.name}</StyledTableCell>
                          <StyledTableCell>{dayjs(row?.date).format("MM/DD/YYYY")}</StyledTableCell>
                          <StyledTableCell align="start">
                            <Box display={'flex'} flexWrap={'wrap'} alignItems={'center'} gap={{ xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}>
                              <Box>
                                <TextLabel fontSize={"12px"} title={"ClockIn"} textAlign={'start'} line />
                                <TextLabel fontSize={"12px"} title={row?.clockInTime ? dayjs(row?.clockInTime).format("LT") : "-"} textAlign={'start'} fontWeight={600} />
                              </Box>
                              <Box>
                                <TextLabel fontSize={"12px"} title={"ClockOut"} textAlign={'start'} line />
                                <TextLabel fontSize={"12px"} title={row?.clockOutTime ? dayjs(row?.clockOutTime).format("LT") : "-"} textAlign={'start'} fontWeight={600} />
                              </Box>
                            </Box>
                          </StyledTableCell>
                          <StyledTableCell>{row.status}</StyledTableCell>
                          {user?.userType !== Roles?.Employe && <StyledTableCell>
                            <Box display={"flex"} gap={1} justifyContent={"center"}>
                              {permissions?.update && (
                                <Assets
                                  className={classes.writeBox}
                                  src={"/assets/icons/write.svg"}
                                  absolutePath={true}
                                  onClick={() => {
                                    setData({ ...row, "employe": row?.employeDetails?.name });
                                    setIsEdit(true);
                                    setModel(true);
                                  }}
                                />
                              )}
                              {permissions?.delete && (
                                <Assets
                                  className={classes.deleteBox}
                                  src={"/assets/icons/delete.svg"}
                                  absolutePath={true}
                                  onClick={() => {
                                    _handleDelete(row?._id);
                                  }}
                                />
                              )}
                            </Box>
                          </StyledTableCell>}
                        </StyledTableRow>
                      );
                    }) :
                      <TableRow>
                        <TableCell colSpan={12}> <DataNotFound icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                        </TableCell>
                      </TableRow>
                    }
                  </TableBody>
                </Table>
              ) : (
                <WidgetLoader />
              )}
            </TableContainer>
          </Grid>
          {employeAttendanceDetails?.count > 0 && <Grid item xs={12}>
            <CustomPagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              count={Math.ceil(employeAttendanceDetails?.count / rowsPerPage)}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage} />
          </Grid>
          }
        </Grid>

      </PaperContainer>

      {model && (
        <CommonModal
          open={model}
          onClose={handleClear}
          title={`${isEdit ? "Update" : "Add"} New Form`}
          maxWidth={'md'}
          content={
            <AddEmployeAttendance
              data={data}
              setData={setData}
              error={error}
              handleChange={handleChange}
              isEdit={isEdit}
              onSubmit={_addUpdateEmployeAttendance}
              employeList={employeList}
              statusList={statusList}
            />
          }
        />
      )}

      {isDwonloadExcel && (
        <CommonModal
          open={isDwonloadExcel}
          onClose={handleClear}
          title={`Dwonload employe attendance`}
          maxWidth={'sm'}
          content={
            <DwonloadEmploye
              dwonloadEmployeId={dwonloadEmployeId}
              setDwonloadEmployeId={setDwonloadEmployeId}
              employeList={employeList}
              dwonloadFilter={dwonloadFilter}
              setDwonloadFilter={setDwonloadFilter}
              dwonloadFilterError={dwonloadFilterError}
              _downloadEmployeAttendance={_downloadEmployeAttendance}
            />
          }
        />
      )}
    </>
  );
};

export default EmployeAttendance;
